import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";
import { toast } from "react-toastify";
import RightArrow from "../../assets/svg/RightArrow";
import search from "../../assets/svg/search.svg";
import axios from "../../components/Hooks/axios";
import { setUserObject } from "../../redux/slices/authSlice";
import styles from "./Privacy.module.scss";

export const FameoX = ({ isMobile }) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [activeOption, setActiveOption] = useState("everyone");
    const [specificUsers, setSpecificUsers] = useState([]);
    const [Search, setSearch] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [disableSwitch, setDisableSwitch] = useState(false);

    const [followers, setFollowers] = useState([]);

    useEffect(() => {
        if (user && user.story_privacy) {
            setActiveOption(user.story_privacy.option || "everyone");
            setSpecificUsers(user.story_privacy.specific_users || []);
        }
    }, [user]);

    useEffect(() => {
        axios.get("/auth/follower-following").then(({ data }) => {
            setFollowers(data?.data?.followersData || []);
        });
    }, []);

    const handleSearch = (query) => {
        setSearch(query);
        if (query.trim() === "") {
            setSearchResults([]);
            return;
        }
        const filtered = followers.filter(f =>
            f.username?.toLowerCase().includes(query.toLowerCase()) ||
            f.displayName?.toLowerCase().includes(query.toLowerCase())
        );
        setSearchResults(filtered);
    };

    const handleOptionChange = async (option) => {
        setDisableSwitch(true);
        const id = toast.loading("Updating story privacy...");
        try {
            const { data } = await axios.post("/auth/change-story-privacy", {
                story_privacy: {
                    option,
                    specific_users: specificUsers
                }
            });
            dispatch(setUserObject(data.data));
            toast.update(id, {
                render: "Story Privacy Updated",
                type: "success",
                isLoading: false,
                autoClose: 2000,
            });
        } catch (error) {
            console.error(error);
            toast.update(id, {
                render: "Failed to update",
                type: "error",
                isLoading: false,
                autoClose: 2000,
            });
        } finally {
            setDisableSwitch(false);
        }
    };

    const toggleUser = async (selectedUser) => {
        const isSelected = specificUsers.some(u => (u._id || u) === selectedUser._id);
        let newUsers;
        if (isSelected) {
            newUsers = specificUsers.filter(u => (u._id || u) !== selectedUser._id);
        } else {
            newUsers = [...specificUsers, selectedUser._id];
        }

        setSpecificUsers(newUsers);

        try {
            const { data } = await axios.post("/auth/change-story-privacy", {
                story_privacy: {
                    option: activeOption,
                    specific_users: newUsers
                }
            });
            dispatch(setUserObject(data.data));
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className={styles.CommentsBox}>
            <div className={styles.CommentsInnerBox}>
                <h1>Story Privacy</h1>
                <p className={styles.InteractionsText}>Who can see your stories</p>
                <div className={styles.AllowTagFrom}>
                    {[
                        { id: "everyone", label: "Everyone" },
                        { id: "followers", label: "Your Followers" },
                        { id: "followers_except", label: "Your Followers Except" },
                        { id: "no_one_except", label: "No One Except" }
                    ].map((opt) => (
                        <div className={styles.OptionRow} key={opt.id}>
                            <div className={styles.OptionHeader}>
                                <h2 className={styles.OptionLabel}>{opt.label}</h2>
                                <Switch
                                    onChange={(checked) => checked && handleOptionChange(opt.id)}
                                    checked={activeOption === opt.id}
                                    disabled={disableSwitch}
                                    offColor={"#F2DBF1"}
                                    onColor={"#F2DBF1"}
                                    offHandleColor={"#A6539D"}
                                    onHandleColor={"#A6539D"}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    activeBoxShadow={"0 0 0px 0px #909AFF"}
                                    height={isMobile ? 30 : 14}
                                    width={isMobile ? 64 : 33}
                                />
                            </div>
                            {opt.id === 'followers' && (
                                <p className={styles.FollowerCount}>
                                    {followers.length} Followers
                                </p>
                            )}
                        </div>
                    ))}

                    {(activeOption === "followers_except" || activeOption === "no_one_except") && (
                        <div style={{ marginTop: '1rem', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
                        <div className={styles.SubPageSearchContainer}>
                            <img src={search} alt="Search" style={{ marginRight: '10px', width: '16px' }} />
                            <input
                                type="text"
                                placeholder="Search followers..."
                                value={Search}
                                onChange={(e) => handleSearch(e.target.value)}
                                className={styles.SubPageSearchInput}
                            />
                        </div>
                        <div className={`hide-scrollbar ${styles.SubPageListScroll}`}>
                                {(() => {
                                    const listToDisplay = Search.trim() === "" ? followers : searchResults;
                                    if (listToDisplay.length === 0) {
                                        return (
                                            <div style={{ textAlign: 'center', padding: '20px', color: '#999', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <p style={{ fontSize: '0.9rem', textTransform: 'none' }}>Follower not found</p>
                                            </div>
                                        );
                                    }
                                    return listToDisplay.map(u => {
                                        const isSelected = specificUsers.some(su => (su._id || su) === u._id);
                                        const isChecked = activeOption === "followers_except" ? !isSelected : isSelected;

                                        return (
                                            <div
                                                key={u._id}
                                                onClick={() => toggleUser(u)}
                                                className={styles.UserListItem}
                                            >
                                                <div className={styles.UserInfo}>
                                                    <img 
                                                        src={u.ProfilePic} 
                                                        alt="" 
                                                        className={styles.UserProfilePic}
                                                        onError={(e) => {
                                                            e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                                                        }}
                                                    />
                                                    <span className={styles.UserName}>{u.displayName || u.username}</span>
                                                </div>
                                                <div
                                                    className={`${styles.CustomCheckbox} ${isChecked ? styles.checked : ''}`}
                                                >
                                                    {isChecked && <span className={styles.CheckIcon}>✓</span>}
                                                </div>
                                            </div>
                                        );
                                    });
                                })()}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

